import script from "./LoaderIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./LoaderIcon.vue?vue&type=script&setup=true&lang=js"

import "./LoaderIcon.vue?vue&type=style&index=0&id=0083b7f4&lang=scss"

export default script